import React, { useEffect, useState } from "react";
import Header from "../../partials/Header";
import Sidebar from "../../partials/Sidebar";
import BackIcon from "../../../assets/icons/icon-back.svg";
import UploadIcon from "../../../images/icon-upload.png";
import { useSelector } from "react-redux";
import { notification } from "antd";
import styles from "./style.module.css";
import { Link, useNavigate } from "react-router-dom";
import AXIOS from "../../../config/axios";
import fetchSiteList from "../../../api/sites/fetchSiteList";
import fetchSizeList from "../../../api/lockers/fetchSizeList";

const LockerAdd = () => {
  const isAuthenticated = useSelector((state) => state.user);
  const isSuperAdmin =
    String(isAuthenticated?.role || "").toLowerCase() === "superadmin";
  const url = process.env.REACT_APP_APP_BACK_URL;
  const [credentials, setCredentials] = useState({
    number: "",
    size_id: "",
    row: "",
    column: "",
    site_id: "",
    relay: "",
    comment: "",
    port: "",
    state:"",
    department_name: "",
  });
  const [departmentAccess, setDepartmentAccess] = useState(false);
  const [departments, setDepartments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [sizes, setSizes] = useState([]);
  const [getSite, setSite] = useState([]);
  const handleInput = (e) => {
    const next = { ...credentials, [e.target.name]: e.target.value };
    if (e.target.name === "site_id") next.department_name = "";
    setCredentials(next);
  };
  const formSubmit = async (e) => {
    e.preventDefault();
    if (!isSuperAdmin) return;
    let headers = new Headers();
    headers.append("Content-Type", "application/json");
    headers.append("Access-Control-Allow-Origin", "*");
    headers.append("Access-Control-Allow-Credentials", "true");
    setIsLoading(true);
    const response = await fetch(`${url}/api/lockers/store`, {
      mode: "cors",
      method: "POST",
      headers: headers,
      body: JSON.stringify({
        number: credentials.number,
        size_id: credentials.size_id,
        site_id: credentials.site_id,
        row: credentials.row,
        column: credentials.column,
        relay: credentials.relay,
        comment: credentials.comment,
        port: credentials.port,
        state:credentials.state,
        department_name: credentials.department_name,
      }),
    });
    setIsLoading(false);
    const json = await response.json();
    console.log(json);
    if (json.success) {
      setCredentials({
        number: "",
        size_id: "",
        site_id: "",
        row: "",
        column: "",
        relay: "",
        comment: "",
        port: "",
        state:"",
        department_name: "",
      });
      notification.success({
        message: "Success",
        description: "Locked added Successfully",
        duration: 3,
      });
    } else {
      setIsLoading(false);
      notification.error({
        message: "Failed",
        description: json.error,
        duration: 3,
      });
    }
  };
  useEffect(() => {
    const siteId = credentials.site_id;
    if (!siteId) {
      setDepartmentAccess(false);
      setDepartments([]);
      return;
    }
    let cancelled = false;
    const headers = new Headers();
    headers.append("auth-token", localStorage.getItem("token"));
    fetch(`${url}/api/sites/getSite/${siteId}`)
      .then((res) => res.json())
      .then(async (json) => {
        const enabled = json?.site?.departments_enabled === "yes";
        if (cancelled) return;
        setDepartmentAccess(enabled);
        if (!enabled) {
          setDepartments([]);
          return;
        }
        const response = await fetch(
          `${url}/api/department/list?site_id=${encodeURIComponent(siteId)}`,
          { headers }
        );
        const list = await response.json();
        if (!cancelled) {
          setDepartments(Array.isArray(list.data) ? list.data : []);
        }
      })
      .catch(() => {
        if (!cancelled) {
          setDepartmentAccess(false);
          setDepartments([]);
        }
      });
    return () => {
      cancelled = true;
    };
  }, [credentials.site_id, url]);
  useEffect(() => {
    (async () => {
      const sizeData = await fetchSizeList();
      if (sizeData) {
        setSizes(sizeData.data);
      }
      const siteData = await fetchSiteList();
      if (siteData) {
        setSite(siteData.site_data);
      }
    })();
  }, []);
  const [isActive, setIsActive] = useState(false);
  // Function to toggle the active state
  const toggleActive = () => {
    setIsActive(!isActive);
  };
  // Define the CSS classes based on the isActive state
  const divClassName = isActive ? "sidebar active" : "sidebar";
  return (
    <div className="general-dashboard">
      <div className="container-fluid">
        <div className="dashboard-top-row add-new-top-row">
          <div className="row">
            <div className="col-lg-6 my-auto">
              <div className="user-wrap user-back-wrap">
                <Link to="/locker/list">
                  <div className="back-icon">
                    <img src={BackIcon} alt="" />
                  </div>
                </Link>
                <div className="user-back-det">
                  <h3>Add Locker</h3>
                  <p>Enter information to add new locker</p>
                </div>
              </div>
            </div>
            <div className="col-lg-6 text-end"></div>
          </div>
        </div>
        {isSuperAdmin ? (
        <form onSubmit={formSubmit}>
          <div className="form-box card-box">
            <div className="row">
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Locker No</h4>
                      <p>Enter the locker number</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="sitec"
                        placeholder="LS-001"
                        name="number"
                        value={credentials.number}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Size</h4>
                      <p>Select size for the locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="size_id"
                        value={credentials.size_id}
                        onChange={handleInput}
                        required
                      >
                        <option value="">Choose size</option>
                        {sizes.map((per) => (
                          <option
                            key={per._id}
                            value={per._id}
                            style={{ textTransform: "capitalize" }}
                          >
                            {per.size}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Row</h4>
                      <p>Enter number of rows for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="row"
                        value={credentials.row}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Column</h4>
                      <p>Enter number of column for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="column"
                        value={credentials.column}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4> Site</h4>
                      <p>Select the site for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="site_id"
                        value={credentials.site_id}
                        onChange={handleInput}
                        required
                      >
                        <option value="" selected>
                          Choose Site
                        </option>
                        {getSite.map((per) => (
                          <option key={per._id} value={per._id}>
                            {per.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              {departmentAccess && (
              <div className="col-lg-6">
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Department</h4>
                      <p>Select a department for this site</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <select
                        name="department_name"
                        value={credentials.department_name || ""}
                        onChange={handleInput}
                      >
                        <option value="">Choose Department</option>
                        {departments.map((item) => (
                          <option key={item._id} value={item.name}>
                            {item.name}
                          </option>
                        ))}
                      </select>
                    </div>
                  </div>
                </div>
              </div>
              )}
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Relay</h4>
                      <p>Enter relay for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="relay"
                        value={credentials.relay}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>

              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Port</h4>
                      <p>Enter port for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="number"
                        className="form-control"
                        id="sitec"
                        placeholder=""
                        name="port"
                        value={credentials.port}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>State</h4>
                      <p>Enter state for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <input
                        type="text"
                        className="form-control"
                        id="state"
                        placeholder="Enter state"
                        name="state"
                        value={credentials.state}
                        onChange={handleInput}
                        required
                      />
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-6">
                {/* input row */}
                <div className="row">
                  <div className="col-xl-5 col-lg-5">
                    <div className="label-wrap">
                      <h4>Comment</h4>
                      <p>Enter comment for locker</p>
                    </div>
                  </div>
                  <div className="col-xl-7 col-lg-7">
                    <div className="inpt-wrap">
                      <textarea
                        name="comment"
                        id=""
                        cols="30"
                        rows="7"
                        value={credentials.comment}
                        onChange={handleInput}
                      ></textarea>
                    </div>
                  </div>
                </div>
                {/* input row */}
              </div>
              <div className="col-lg-12 text-end">
                <div className="form-btn-wrap mb-5 pb-5">
                  <button
                    type="submit"
                    className="btn btn-prim w-auto ms-5"
                    disabled={isLoading}
                  >
                    {isLoading ? "Adding..." : "Add Locker"}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </form>
        ) : (
          <div className="form-box card-box">
            <p>Only a super admin can add lockers.</p>
          </div>
        )}
      </div>
    </div>
  );
};
export default LockerAdd;
